import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CONTEXT_PATH_API} from '@shared/config';
import {DocumentUploadedFile} from '@shared/features';

interface Context {
  file: DocumentUploadedFile,
  subCaseId: string;
  caseId: string;
}

@Component({
  selector: '[cl-file-upload-view-dialog-content]',
  templateUrl: './file-upload-view-dialog-content.component.html',
  styleUrls: ['./../file-preview-dialog/file-preview-dialog.scss']
})
export class FileUploadViewDialogContentComponent implements AfterViewInit {

  @ViewChild('pdfViewer', { read: ElementRef }) pdfViewer: ElementRef;

  path: string = CONTEXT_PATH_API;

  constructor(public dialogDef: MatDialogRef<FileUploadViewDialogContentComponent>,
              @Inject(MAT_DIALOG_DATA) public context: Context) {
  }

  ngAfterViewInit() {
    if (this.pdfViewer) {
      const iframe = this.pdfViewer.nativeElement.querySelector('iframe');
      if (iframe) {
        const dialogContainer = iframe.closest('.mat-dialog-container, .mat-mdc-dialog-container');
        const dialogHeight = dialogContainer.clientHeight;
        const iframeHeight = dialogHeight - 120;
        iframe.style.height = iframeHeight + 'px';
        iframe.style.width = '100%';
      }
    }
  }

  getCloseAriaLabel(): string {
    return `Zamknij okno dialogowe '${this.context.file.fileSaved.name}'`;
  }

  isPdf(): boolean {
    return this.context.file.fileSaved.contentType.indexOf('pdf') > -1;
  }

  getSrc() {
    const part = this.context.subCaseId ? 'sub-case' : 'case';
    return `${CONTEXT_PATH_API}/document/${part}/${this.context.file.fileSaved.id}`;
  }
}
